export default "__VITE_ASSET__CMEKPi4a__"